import ApplicationDetail from './detail';
export default ApplicationDetail;
